<template>
  <v-row class="pl-2">
    <v-btn
      icon
      @click="onPrev"
      color="#ADD7F6"
      dark
      class="af-pagination-navigation v-pagination__navigation left-button"
      :disabled="!prevEnabled"
    >
      <v-icon>fa-caret-left</v-icon>
    </v-btn>
    <div class="page-display">
      {{ startItems + "-" + endItems + "/" + value.totalItems }}
    </div>
    <v-btn
      icon
      @click="onNext"
      dark
      class="af-pagination-navigation v-pagination__navigation right-button"
      :disabled="!nextEnabled"
    >
      <v-icon>fa-caret-right</v-icon> </v-btn
    >&nbsp;&nbsp;&nbsp;
    <div class="form-inline entries-display">
      <div class="form-group">
        <select
          class="custom-select form-control"
          id="entriesSelect"
          v-model="value.itemsPerPage"
          @change="onitemsPerPageChange"
        >
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="30">30</option>
          <option :value="40">40</option>
          <option :value="50">50</option>
          <option :value="60">60</option>
          <option :value="100">100</option>
        </select>
        <label for="entriesSelect">entries</label>
      </div>
    </div>
  </v-row>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      // page: 1,
      // pages: 0,
      // startItems: 0,
      // endItems: 0,
    };
  },

  watch: {
    value() {
      console.log("value: ", this.value);
    },
  },

  methods: {
    onNext() {
      this.value.page++;
      this.$emit("input", this.value);
      this.$emit("next");
    },

    onPrev() {
      this.value.page--;
      this.$emit("input", this.value);
      this.$emit("prev");
    },

    onitemsPerPageChange() {
      this.$emit("input", this.value);
      this.$emit("rows-per-page-change");
    },
  },

  computed: {
    nextEnabled() {
      return this.value.page < this.pages;
    },

    prevEnabled() {
      return this.value.page > 1;
    },

    pages: {
      get() {
        if (this.value == null) {
          return 0;
        }

        return Math.ceil(this.value.totalItems / this.value.itemsPerPage);
      },
    },

    startItems: {
      get() {
        return Math.max(this.endItems - this.value.itemsPerPage + 1, 1);
      },
    },

    endItems: {
      get() {
        return Math.min(this.value.page * this.value.itemsPerPage, this.value.totalItems);
      },
    },
  },
};
</script>

<style>
.af-pagination-container {
  padding-left: 10px;
  width: 350px;
  height: 36px;
}

.af-pagination-navigation.v-btn--icon {
  /* box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 
        0px 2px 2px 0px rgba(0,0,0,0.14), 
        0px 1px 5px 0px rgba(0,0,0,0.12) !important; */
  box-shadow: none;
  margin: 0px 0px 4px 0px;
  line-height: 28px;
  height: 28px;
  width: 28px;
  border-radius: 6px;
  background-color: #add7f6;
}

.af-pagination-navigation.v-btn--icon.left-button {
  border-top-right-radius: 0%;
  border-bottom-right-radius: 0%;
}

.af-pagination-navigation.v-btn--icon.right-button {
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
}

.af-pagination-navigation.v-btn--icon .v-icon {
  font-size: 24px !important;
  color: black;
}

.page-display {
  background-color: #ffffff;
  box-sizing: border-box;
  height: 2rem;
  line-height: 2rem;
  padding: 0 8px;
  /* margin-top: 0.1rem; */
  display: inline-block;

  /* border-radius: 4px; */

  /* box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12); */
}

.entries-display {
  display: inline-block !important;
}

.entries-display .custom-select {
  width: 50px !important;
  margin: 0 5px 0 5px;
}
</style>
